/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {EmailMakerControl} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import type {InfoBoxControlInnerProps, InfoBoxDescriptor} from './info-box-control.types';
import styles from './info-box-control.module.scss';

function InfoBoxControlInner({descriptor}: InfoBoxControlInnerProps): ReactElement {
  return (
    <div className={`${styles.wrapper} info-wrapper ${descriptor.variantClass}`}>
      <div className="info-box">
        <Text className="info-message" dangerouslySetInnerHTML size={TextSize.MD} val={window.i18next.t(descriptor.contentKey)} />
      </div>
    </div>
  );
}

export function makeInfoBoxControl(descriptor: InfoBoxDescriptor): EmailMakerControl {
  return createDescriptorControl(InfoBoxControlInner, descriptor);
}
